<header *ngIf="showBanner">
    <div class="imgDiv"><img src="/assets/img/logo_eli_white.png" /></div>
    <div class="titleDiv"><h4><b>{{currentAssessmentName}}</b></h4></div>
</header>


<ng-progress [spinner]="false" [color]="'#7ab655'"></ng-progress>

<div *ngIf="!ready; else assessment" class="main-content" [ngClass]="{'margin-content': showBanner}" (window:resize)="onResize($event)">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <div>
                        <h1 *ngIf="!showBanner" class="h3 text-gray-800">{{currentAssessmentName}}</h1>
                        <p *ngIf="userType == 4" class="fullName">For: {{fullName}}</p>
                    </div>
                    <!--<ng-container *ngIf="accept">-->
                    <div *ngIf="data; else text">
                        <a (click)="userReady()" *ngIf="hasId"
                           class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm readyBtn">
                            <!--<i class="fas fa-arrow-right text-white-50"> <span class="button-text">I'm ready to begin!</span></i>-->
                            <span class="button-text">{{ 'ASSIGNED_ASSESSMENT.READY_BUTTON' | translate }}</span><i class="fas fa-caret-right"></i>
                        </a>
                        <a (click)="userReady()" *ngIf="!hasId"
                           class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm readyBtn">
                            <!--<i class="fas fa-arrow-right text-white-50"> <span class="button-text">I'm ready to begin!</span></i>-->
                            <span class="button-text">{{ 'ASSIGNED_ASSESSMENT.READY_BUTTON' | translate }}</span><i class="fas fa-caret-right"></i>
                        </a>
                    </div>

                    <ng-template #text>
                        <button disabled class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm readyBtn">
                            {{ 'ASSIGNED_ASSESSMENT.LOADING_BUTTON' | translate }} <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i>
                        </button>
                    </ng-template>
                </div>

                

                <div class="card shadow" style="margin:15px 0; padding: 15px 0;">

                    <div class="container-fluid">

                        <div class="tab-pane fade in active">
                            <ng-container *ngIf="loading">
                                <div class="text-center">
                                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="color:#46a8ce; font-size: 75px;"></i>
                                    <p>Loading, please wait...</p>
                                </div>
                            </ng-container>

                            <div class="container-fluid" id="pageContent"></div>
                        </div>

                    </div>
                    <!--<div *ngIf="from == 'rater'" class="container-fluid">
                        <p>Thank you for participating in iPEC's 360 assessment process. </p>

                        <br />

                        <p>Please fill out the following questions with regard to the person you have been asked to rate. We ask that you carefully consider your answers and that you be as honest as possible so that the person being rated can benefit from the process. Your responses will be combined with other responses and represented as an average.</p>

                        <br />

                        <p>Your individual responses and your name are not identified in Feedback Report. If a particular question does not apply because of your relationship to the person you are rating, please leave it blank.</p>
                    </div>-->
                </div>

            </div>

        </div>
    </div>
</div>

<!--assessment-->
<ng-template #assessment>
    <div class="main-content takingAssessment" (window:resize)="onResize($event)">
        <div class="container-fluid">
            <div class="row">

                <!--<div id="countdown" style="font-size: 9px;text-align:-webkit-right; display:none;"></div>-->

                <div class="col-md-12">

                    <div *ngIf="!loading" class="row">

                        <ng-container *ngIf="previewMode">
                            <!--<div class="navigation-btns-container table-actions-buttons text-right" style="margin-right: 15px;position: absolute;top: -105px;z-index: 99;right: 35px;">
                                <input style="width: auto;" (click)="finishAssessment()" type="button" value="Back to Assessment" class="btn navigation-btns btn-warning">
                            </div>-->
                            <a (click)="finishAssessment()" class="backToBtn btn btn-primary shadow-sm">
                                <i class="fas fa-undo"> <span class="button-text"> Back to Assessment</span></i>
                            </a>
                        </ng-container>

                        <div *ngIf="!hideNavigationBtns" class="col-md-3 text-left">
                            <ng-container *ngIf="!responsiveButtons">

                                <!--*ngIf="(currentSectionIndex > 0 || from != 'rater')"-->
                                <ng-container *ngIf="!onCommentsPage; else onCommentsPageElsePrev">
                                    <div class="backNext" *ngIf="showBackButton()" style="position:relative;">
                                        <button (click)="showPrevQuestion()" style="position:absolute;top:12px;color:white;left:30px;cursor:pointer;margin-left:10px;" class="back">{{ 'ASSIGNED_ASSESSMENT.BACK_BUTTON' | translate }}</button>
                                    </div>
                                </ng-container>
                                <ng-template #onCommentsPageElsePrev>
                                    <div class="backNext" *ngIf="globalCurrentQuestion>1" style="position:relative;">
                                        <button (click)="backFromComments()" style="position:absolute;top:12px;color:white;left:30px;cursor:pointer;margin-left:10px;" class="back">{{ 'ASSIGNED_ASSESSMENT.BACK_BUTTON' | translate }}</button>
                                    </div>                                
                                </ng-template>

                            </ng-container>
                        </div>

                        <div *ngIf="!finish" class="col-md-6 text-center">
                            <div *ngIf="!assessment360Finished && !showMissingAnswers">
                                <h4 style="margin-bottom:-15px; font-weight:bold;">{{currentAssessmentName}}</h4>
                                <div class="questionData">
                                    <p *ngIf="userType == 4" style="margin: 18px 0 -12px 0;">For: {{fullName}}</p>
                                    <h4 *ngIf="singleChoice" class="questions" style="margin-top:13px;font-size:18px;">{{ 'ASSIGNED_ASSESSMENT.QUESTION' | translate }} <span id="questionIndex">{{globalCurrentQuestion}}</span> {{ 'ASSIGNED_ASSESSMENT.OF' | translate }} <span id="questionsTotal">{{ questionsTotal }}</span></h4>
                                    <p *ngIf="reviewingMissingAnswers" class="missingAnswerWarning" [ngClass]="{'showWarning': isCurrentQuestionMissing()}">{{ 'ASSIGNED_ASSESSMENT.MISSING_ANSWER_WARNING' | translate }}</p>
                                    <!--skip checkbox, only after ProcessAssessment returned missing answers (-2)-->
                                    <label *ngIf="reviewingMissingAnswers" style="display:block;margin:8px 0 0 0;font-weight:normal;cursor:pointer;">
                                        <input type="checkbox" [checked]="skipToMissingAnswers" (change)="skipToMissingAnswers = $event.target.checked">
                                        {{ 'ASSIGNED_ASSESSMENT.SKIP_MISSING_CHECKBOX' | translate }}
                                    </label>
                                    <p style="font-size: 18px;font-weight: bold;">{{currentHeader}}</p>
                                </div>
                                <div class="commentsTitle" style="display:none;">
                                    <p style="font-size: 18px;font-weight: bold;margin-top: 20px;">Comments</p>
                                </div>

                            </div>

                        </div>

                        <!--title for assessment 360-->
                        <!--<div *ngIf="assessment360Finished" class="text-center"><h4 style="margin-bottom:-10px; font-weight:bold;">{{currentAssessmentName}}</h4></div>-->

                        <div *ngIf="!hideNavigationBtns" class="col-md-3 text-right">
                            <ng-container *ngIf="!responsiveButtons">
                                <div class="backNext" style="position:relative;padding-top: 13px;">
                                    <ng-container *ngIf="globalCurrentQuestion == questionsTotal && showCommentsSection; else showCommentsSectionElse">
                                        <button *ngIf="!onCommentsPage; else onCommentsPageElse" (click)="displayCommentsSection()" class="button"> {{ 'ASSIGNED_ASSESSMENT.NEXT_BUTTON' | translate }}</button>
                                        <ng-template #onCommentsPageElse>
                                            <button (click)="finishAssessmentsWithComments()" style="position:absolute;top:12px;color:white;right:30px;cursor:pointer;margin-right:0px;" class="button"> {{ 'ASSIGNED_ASSESSMENT.FINISH_BUTTON' | translate }}</button>
                                        </ng-template>
                                    </ng-container>

                                    <ng-template #showCommentsSectionElse>
                                        <button (click)="showNextQuestion()" *ngIf="sections[sections.length-1].Questions[sections[sections.length-1].Questions.length-1].Id == currentQuestionId; else nextButton1;" style="position:absolute;top:12px;color:white;right:30px;cursor:pointer;margin-right:0px;" class="button"> {{ 'ASSIGNED_ASSESSMENT.FINISH_BUTTON' | translate }}</button>
                                        <ng-template #nextButton1>
                                            <button (click)="showNextQuestion()" class="button"> {{ 'ASSIGNED_ASSESSMENT.NEXT_BUTTON' | translate }}</button>
                                        </ng-template>
                                    </ng-template>

                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <!--<div *ngIf="!loading" class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">


                        <div *ngIf="!hideNavigationBtns" class="buttons-container" style="margin-top: 15px;position: relative;height: 45px;">
                            <ng-container *ngIf="!responsiveButtons">
                                <input *ngIf="globalCurrentQuestion>1" (click)="showPrevQuestion()" type="button" value="Back" class="btn navigation-btns">
                                 <input (click)="showNextQuestion()" type="button" [value]="globalCurrentQuestion != questionsTotal ? 'Next': 'Finish'" class="btn navigation-btns">
                            </ng-container>
                        </div>

                    </div>-->

                    <ng-container *ngIf="loading || gettingData.length > 0">
                        <div class="loading text-center">
                            <img src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                            <p>{{loadingMessage}}</p>
                        </div>
                    </ng-container>

                    <div [hidden]="!(!loading && gettingData.length === 0)" style="margin-bottom: 46px;">
                        <div class="custom_card shadow" style="margin-top: 15px;">
                            <div class="header">
                                <!--<h4 class="title"></h4>
        <p class="category"></p>-->
                            </div>

                            <!--Missing answers (ProcessAssessment result -2)-->
                            <div *ngIf="showMissingAnswers" class="container-fluid text-center" style="padding: 40px 25px 15px 25px;">
                                <h3 class="h3 text-gray-800" style="margin-top:0;">{{ 'ASSIGNED_ASSESSMENT.MISSING_ANSWERS_TITLE' | translate }}</h3>
                                <p style="font-size:16px;margin:15px 0 25px 0;white-space:pre-line;">{{ 'ASSIGNED_ASSESSMENT.MISSING_ANSWERS_MESSAGE' | translate:{ count: missingAnswersCount } }}</p>
                                <button (click)="goToMissingAnswer()" class="btn btn-other shadow-sm">
                                    {{ 'ASSIGNED_ASSESSMENT.MISSING_ANSWERS_BUTTON' | translate }}
                                </button>
                            </div>

                            <ng-container *ngIf="showAssessment">
                                <div class="container-fluid" style="margin-bottom: 15px;">
                                    <ng-container *ngIf="questionsContent">
                                        <div class="questionsHeader">
                                            <div class="text-right">
                                                <i *ngIf="from_admin" [routerLink]="['/app/edit_eli', _Globals.previewAssessmentId]" class="small material-icons">undo</i>
                                                <i *ngIf="from_client" [routerLink]="['/app/client_assessments']" class="small material-icons">home</i>
                                                <!-- <i class="small material-icons">info_outline</i> -->
                                                <!--<i (click)="nextQuestion()" class="rotate180 large material-icons">keyboard_backspace</i>-->
                                                <!--<i *ngIf="showNextIcon" (click)="showPrevQuestion()" class="large material-icons">keyboard_backspace</i>-->
                                                <!-- <i *ngIf="showNextIcon" (click)="showNextQuestion()" class="rotate180 large material-icons">keyboard_backspace</i> -->
                                            </div>
                                            <!--<h3>Assessment</h3>-->
                                            <!--<h4>Question <span id="questionIndex">{{globalCurrentQuestion}}</span> of <span id="questionsTotal">{{ questionsTotal }}</span></h4>-->
                                        </div>

                                        <!--Regular Questions-->
                                        <ng-container *ngIf="!showIcons && singleChoice">
                                            <ng-container *ngIf="displayMode == 1">
                                                <div class="questionSection">
                                                    <div>
                                                        <p class="isQuestion">
                                                            {{sections[currentSectionIndex].Questions[currentQuestionIndex].Text}}
                                                        </p>
                                                    </div>

                                                    <div class="buttons">
                                                        <div *ngFor="let sectionChoice of currentSectionChoices; let i = index" class="btn-group" data-toggle="buttons">
                                                            <label style="min-width: fit-content;" [ngClass]="{'active': sections[currentSectionIndex].Questions[currentQuestionIndex].Answer == sectionChoice.Id}"
                                                                   (click)="setOneActive($event)" id="{{sectionChoice.Id}}" class="btn btn-info form-check-label">
                                                                <input name="answers"
                                                                       id="input{{sectionChoice.Id}}"
                                                                       value="{{sectionChoice.Text | replaceSpaces}}"
                                                                       class="form-check-input"
                                                                       type="radio"
                                                                       [checked]="sections[currentSectionIndex].Questions[currentQuestionIndex].Answer == sectionChoice.Id"
                                                                       autocomplete="off">
                                                                <i class="fa fa-spinner fa-pulse fa-3x fa-fw d-none" style="font-size:20px;padding:0;position: relative;top:0px;"></i>
                                                                {{sectionChoice.Text}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="commentsSection" style="display:none;">
                                                    <textarea placeholder="Anything else you would like to share about {{clientInfo.FirstName}} {{clientInfo.LastName}}?" id="commentsArea" [value]="commentsText" rows="8" style="resize:vertical;width: 100%;padding:10px;min-height:100px;"></textarea>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                        <!--Regular Questions END-->

                                        <!--Satisfaction questions-->
                                        <ng-container *ngIf="singleChoice">
                                            <ng-container *ngIf="displayMode == 2">

                                                <div>
                                                    <div *ngFor="let question of multipleQuestions; let i = index">
                                                        <p class="isQuestion">{{globalCurrentQuestion+(i)}}. {{question.Text}}</p>

                                                        <!--existing-->
                                                        <input *ngIf="question.Answer > 0" #face class="form-check-input" type="radio" name="face{{globalCurrentQuestion+(i)}}" [value]="question.Answer" style="opacity:0;" />

                                                        <!--new-->
                                                        <input *ngIf="question.Answer == 0" #face class="form-check-input" type="radio" name="face{{globalCurrentQuestion+(i)}}" value="" style="opacity:0;" />

                                                        <div class="buttons" *ngIf="!showIcons" style="position:relative;top:-35px;">
                                                            <div class="buttons-wrap">
                                                                <div *ngFor="let sectionChoice of currentSectionChoices" class="btn-group" data-toggle="buttons">
                                                                    <label [ngClass]="{'active': question.Answer == sectionChoice.Id}" (click)="selectFace($event, globalCurrentQuestion+(i))" [attr.data-question-id]="question.Id" [attr.data-choice-id]="sectionChoice.Id" id="{{sectionChoice.Id}}" class="btn btn-info form-check-label">
                                                                        <input name="answers"
                                                                               value="{{sectionChoice.Text | replaceSpaces}}"
                                                                               class="form-check-input"
                                                                               type="radio"
                                                                               [checked]="question.Answer == sectionChoice.Id"
                                                                               autocomplete="off">
                                                                        {{sectionChoice.Text}}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="faces" *ngIf="showIcons">
                                                            <div *ngFor="let choice of currentSectionChoices | slice:0:3">
                                                                <i (click)="selectFace($event, globalCurrentQuestion+(i))" [attr.data-question-id]="question.Id" [attr.data-choice-id]="choice.Id" [ngClass]="{'active': question.Answer == choice.Id}" title="{{choice.Text}}" class="{{choice.Text | replaceSpaces}} material-icons">mood_bad</i>
                                                            </div>
                                                            <div *ngFor="let choice of currentSectionChoices | slice:3:6">
                                                                <i (click)="selectFace($event, globalCurrentQuestion+(i))" [attr.data-question-id]="question.Id" [attr.data-choice-id]="choice.Id" [ngClass]="{'active': question.Answer == choice.Id}" title="{{choice.Text}}" class="{{choice.Text | replaceSpaces}} material-icons active">mood</i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                        <!--Satisfaction questions-->

                                        <!--Survey / demographics questions-->
                                        <ng-container *ngIf="!singleChoice && !showIcons">
                                            <div #selects>
                                                <div *ngFor="let questionChoice of questionChoices; let i = index;" class="demographics">
                                                    <div class="row text-center">
                                                        <div class="col-md-offset-2 col-md-4 text-left" style="display:flex;">
                                                            <label id="label{{questionChoice.Id}}" style="width:100% !important;" class="isQuestion">{{globalCurrentQuestion+(i)}}. {{questionChoice.Text}} <span *ngIf="questionChoice.IsMandatory == true" class="mandatory">*</span></label>
                                                        </div>
                                                        <div class="col-md-4" style="position:relative;">
                                                            <select  style="width: 100%;" #_survey
                                                                    [id]="'select' + questionChoice.Id"
                                                                    [attr.data-index]="i"
                                                                    (change)="selectSurvey(_survey.value, $event)"
                                                                    [ngClass]="{'isMandatory': questionChoice.IsMandatory}">
                                                                <option selected></option>
                                                                <option *ngFor="let property of questionChoice.Choices; let j = index;"
                                                                        [selected]="questionChoice.Answer == property.Id"
                                                                        [id]="property.Id"
                                                                        [value]="property.Id">
                                                                    {{property.Text}}
                                                                </option>
                                                            </select>
                                                            <!--[attr.data-question-id]="questionChoice.Id"-->
                                                            <!-- [attr.data-index]="i" -->
                                                            <input (blur)="saveFreeEntryAnswer(questionChoice.Id, $event)" [id]="'input'+ questionChoice.Id" hidden  style="width: 100%; height: 35px; margin-top: 10px;" type="text" placeholder="Enter value">

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <!--Survey questions-->
                                    </ng-container>

                                    <!--actually disabled finishh not exist-->
                                    <ng-container *ngIf="finishh">
                                        <!--<div class="text-center">
                    <h2><b>Thank you!</b></h2>
                    <p>
                        You have completed the assessment. You will be contacted soon to schedule your debrief.
                        Your report will be available at the "Reports" section once it is approved by your coach.
                    </p>
                </div>
                <div class="text-right">
                    <input type="button" class="btn btn-info" value="Finish" (click)="finishAssessment()" />
                </div>-->
                                        <div class="row">
                                            <div class="col-md-10">
                                                <h2>Assessments Results</h2>
                                            </div>
                                            <!--<div class="col-md-2 text-right" style="position:absolute; right: 216px;">
                        <i (click)="downloadAssessment()" class="material-icons custom-icons">file_download</i>
                        <i [routerLink]="['/app/client_assessments']" class="small material-icons">home</i>
                    </div>-->
                                            <div class="navigation-btns-container table-actions-buttons text-right" *ngIf="hideNavigationBtns" style="margin-right: 15px;">
                                                <input (click)="finishAssessment()" type="button" value="Finish" class="btn navigation-btns btn-warning">
                                            </div>
                                        </div>

                                        /d

                                        <div class="row">
                                            <div class="col-md-12">
                                                <p class="subTitle">{{ARL.Name}} : <span class="alv"> <b> {{ARL.Values[0].Value}} </b> </span></p>
                                            </div>
                                            <!--<div class="col-md-9">
                            <input style="width: 80%;" class="input_readonly" readonly type="text" id="arl" value="{{ARL.Values[0].Value}}" />
                    </div>-->
                                        </div>

                                        <hr />

                                        <div class="row">
                                            <!--graphic-->
                                            <div class="col-md-9 images">
                                                <div class="graphics">
                                                    <div style="display: block">
                                                        <p class="graphicTitle">{{graphicTitle1}}</p>
                                                        <div class="graphicsValues" style="position:relative;">
                                                            <div>
                                                                <p *ngFor="let level of levels1; let i = index;" class="level{{7-i}}">Level {{7 - i}}</p>
                                                                <span *ngFor="let level of levels1; let i = index;" class="level{{7-i}}">{{level}}%</span>
                                                            </div>
                                                            <span *ngFor="let level of levels1; let i = index;" class="level{{7-i}}">{{level}}%</span>
                                                            <canvas baseChart [datasets]="ERGraphicDatasets" [labels]="ERGraphicLabel" [options]="ERGraphicOptions" [legend]="ERGraphicLegend" [chartType]="ERGraphicChartType" [colors]="colors"></canvas>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <hr />

                                        <div class="row">
                                            <!--graphic-->
                                            <div class="col-md-9 images">
                                                <div class="graphics">
                                                    <div style="display: block">
                                                        <p class="graphicTitle">{{graphicTitle2}}</p>
                                                        <div class="graphicsValues" style="position:relative;">
                                                            <div>
                                                                <p *ngFor="let level of levels2; let i = index;" class="level{{7-i}}">Level {{7 - i}}</p>
                                                                <span *ngFor="let level of levels2; let i = index;" class="level{{7-i}}">{{level}}%</span>
                                                            </div>
                                                            <span *ngFor="let level of levels2; let i = index;" class="level{{7-i}}">{{level}}%</span>
                                                            <canvas baseChart [datasets]="ERPGraphicDatasets" [labels]="ERPGraphicLabel" [options]="ERPGraphicOptions" [legend]="ERPGraphicLegend" [chartType]="ERPGraphicChartType" [colors]="colors"></canvas>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="!assessment360Finished">
                                <div class="container-fluid" style="margin-bottom: 15px;">
                                    <div class="container-fluid" id="thankYouPageContent" style="padding: 25px 0 0 0;"></div>
                                    <hr class="my-4">
                                </div>
                            </ng-container>

                            <!--Assessment360 finished-->
                            <div *ngIf="assessment360Finished">
                                <div class="container-fluid" id="thankYou360PageContent" style="padding: 25px;"></div>
                                <hr class="my-4">
                            </div>

                        </div>
                        <!--custom_card END -->
                        <ng-container *ngIf="showDownButtons && !hideNavigationBtns">
                            <!--<div class="navigation-btns-container" *ngIf="!hideNavigationBtns" style="margin-bottom: 15px;text-align: right;margin-right: 16px;">
                                <input *ngIf="globalCurrentQuestion>1" (click)="showPrevQuestion()" type="button" value="Back" class="btn navigation-btns">
                                <input (click)="showNextQuestion()" type="button" [value]="globalCurrentQuestion != questionsTotal ? 'Next': 'Finish'" class="btn navigation-btns">
                            </div>-->
                            
                            <div class="row" id="showDownButtons">
                                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                                    <!--<div class="aResponsiveBtns">
                                        <a *ngIf="globalCurrentQuestion>1" (click)="showPrevQuestion()" class="btnPrev navigation-btns">Back</a>
                                    </div>
                                    <div class="aResponsiveBtns">
                                        <a (click)="showNextQuestion()" class="btnNext navigation-btns">{{sections[currentSectionIndex].ShowIcons || sections[currentSectionIndex].SingleChoice ? 'Next': 'Finish'}}</a>
                                    </div>-->
                                    <div style="position:relative;margin-top:35px;margin-left:30px;">
                                        <!--back-->
                                        <ng-container *ngIf="!onCommentsPage; else onCommentsPageElsePrevResponsive">
                                            <div class="backNext" *ngIf="showBackButton()">
                                                <button (click)="showPrevQuestion()"
                                                        style="position:absolute;top:-29px;color:white;left:30px;cursor:pointer;margin-left:10px;" 
                                                        class="back">{{ 'ASSIGNED_ASSESSMENT.BACK_BUTTON' | translate }}</button>
                                            </div>
                                        </ng-container>
                                        <!--back from comments-->
                                        <ng-template #onCommentsPageElsePrevResponsive>
                                            <div class="backNext" *ngIf="globalCurrentQuestion>1">
                                                <button (click)="backFromComments()" 
                                                        style="position:absolute;top:12px;color:white;left:30px;cursor:pointer;margin-left:10px;" 
                                                        class="back">{{ 'ASSIGNED_ASSESSMENT.BACK_BUTTON' | translate }}</button>
                                            </div>
                                        </ng-template>
                                    </div>

                                    <div class="backNext" style="position:relative;margin-top:35px;margin-right:30px;">

                                        <!--in comments-->
                                        <ng-container *ngIf="globalCurrentQuestion == questionsTotal && showCommentsSection; else showCommentsSectionElseResponsive">
                                            <!--next to comments-->
                                            <button *ngIf="!onCommentsPage; else onCommentsPageElseResponsive" 
                                                    (click)="displayCommentsSection()" 
                                                    class="button"> {{ 'ASSIGNED_ASSESSMENT.NEXT_BUTTON' | translate }}</button>
                                            <!--finish with comments-->
                                            <ng-template #onCommentsPageElseResponsive>
                                                <button (click)="finishAssessmentsWithComments()" 
                                                        style="position:absolute;top:12px;color:white;right:30px;cursor:pointer;margin-right:0px;" 
                                                        class="button"> {{ 'ASSIGNED_ASSESSMENT.FINISH_BUTTON' | translate }}</button>
                                            </ng-template>
                                        </ng-container>

                                        <!--next-->
                                        <ng-template #showCommentsSectionElseResponsive>
                                            <button (click)="showNextQuestion()" 
                                                    *ngIf="sections[sections.length-1].Questions[sections[sections.length-1].Questions.length-1].Id == currentQuestionId; else nextButton2;" 
                                                    style="position:absolute;top:12px;color:white;right:30px;cursor:pointer;margin-right:0px;margin-top:-41px;" 
                                                    class="button"> {{ 'ASSIGNED_ASSESSMENT.FINISH_BUTTON' | translate }}</button>
                                            <ng-template #nextButton2>
                                                <button (click)="showNextQuestion()" 
                                                        class="button"> {{ 'ASSIGNED_ASSESSMENT.NEXT_BUTTON' | translate }}</button>
                                            </ng-template>
                                        </ng-template>
                                    </div>

                                </div>
                            </div>

                        </ng-container>

                    </div>

                </div>
            </div>
        </div>
    </div>
</ng-template>
